import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import SelectAssessment from '@views/Assessments/SelectAssessment';
import MainWrapper from '@views/Records/Common/MainWrapper';

const messages = defineMessages({
  title: {
    id: 'assessmentsMain.title',
    defaultMessage: 'Assessments',
  },
});

export default function AssessmentTypesPage() {
  const { formatMessage } = useIntl();

  return (
    <MainWrapper
      backgroundIcon="logo"
      friendlyName={formatMessage(messages.title)}
      showBreadcrumb={false}
      showHeader
      title={formatMessage(messages.title)}
    >
      <SelectAssessment />
    </MainWrapper>
  );
}
